import {Component, input, OnChanges, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {ExamInvolvement} from '../../../../api/models/exam-involvement';
import {StaffMember} from '../../../../api/models/staff-member';
import {Survey} from '../../../../api/models/survey';
import {User} from '../../../../api/models/user';

import {MessageService} from '../../../../api/services/message.service';
import {SurveyService} from '../../../../api/services/survey.service';
import {WaCalloutDirective, WaIconDirective} from "angular-awesome";
import {CorrectionListElementComponent} from "./correction-list-element/correction-list-element.component";

@Component({
  selector: 'app-correction-list',
  templateUrl: './correction-list.component.html',
  styleUrls: ['./correction-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaCalloutDirective, WaIconDirective,CorrectionListElementComponent]
})
export class CorrectionListComponent implements OnInit, OnChanges {

  readonly user = input<User | null>(null);
  readonly survey = input<Survey | null>(null);
  readonly staffMember = input<StaffMember | null>(null);
  readonly withoutStaffMember = input(false);

  totalCount: number = 0;
  corrections: ExamInvolvement[] = [];

  constructor(private msgService: MessageService, private surveyService: SurveyService) {
  }

  ngOnInit(): void {
    this.getCorrections();
  }

  ngOnChanges(): void {
    this.getCorrections();
  }

  private getCorrections(): void {
    if (!this.stateValid()) return;

    const id = this.survey()!.id;
    const staffMember = this.staffMember();
    const staffMemberId = !!staffMember ? staffMember.id : null;

    this.surveyService.getCorrections(id, staffMemberId).subscribe({
      next: result => {
        this.corrections = result.data;
        this.totalCount = result.count;
      }, error: err => {
        const msg = 'Could not get correction assignments.';
        this.msgService.log(err.message);
        this.msgService.showSimple(msg);
      }
    });
  }

  private stateValid(): boolean {
    return !!this.user() && !!this.survey() && (!!this.staffMember() || this.withoutStaffMember());
  }
}
